import map_ from 'lodash/map';
import reduce_ from 'lodash/reduce';

import moment from 'moment';

import ypath from '../../../../../common/thor/ypath';
import isEmpty_ from 'lodash/isEmpty';

export class Event {
    constructor(data) {
        Object.assign(this, data);
    }

    static COMPLETED_STATES = ['completed', 'failed', 'aborted'];

    static isFinalState(event) {
        return Event.COMPLETED_STATES.indexOf(event.state) !== -1;
    }

    static isNotFinalState(event) {
        return !Event.isFinalState(event);
    }
}

function durationToPercentage(duration, totalDuration) {
    return (duration / totalDuration) * 100;
}

function prepareEvents(events, params) {
    let showAttributesColumn = false;
    const {finishTime: endTime} = params;

    if (events) {
        let lastState;
        let preparedEventsData = reduce_(
            events,
            (prepared, event, index) => {
                const nextEvent = events[index + 1];
                let duration;
                let finishTime;

                if (event.state) {
                    lastState = event.state;
                }

                if (nextEvent) {
                    finishTime = nextEvent.time;
                    duration = moment(finishTime) - moment(event.time);
                } else {
                    finishTime = endTime ? endTime : moment().toISOString();
                    duration = moment(finishTime) - moment(event.time);
                }

                if (!isEmpty_(event.attributes)) {
                    showAttributesColumn = true;
                }

                prepared.totalDuration += duration;
                prepared.events.push(
                    new Event({
                        duration,
                        finishTime,
                        time: event.time,
                        state: event.state || lastState,
                        originalState: event.state,
                        phase: event.phase,
                        attributes: event.attributes,
                    }),
                );

                return prepared;
            },
            {events: [], totalDuration: 0, precedingDuration: 0},
        );

        const eventsDurations = map_(preparedEventsData.events, 'duration');

        preparedEventsData = reduce_(
            eventsDurations,
            (prepared, duration, index) => {
                const currentEvent = prepared.events[index];
                const totalDuration = prepared.totalDuration;
                const precedingDuration = prepared.precedingDuration;

                currentEvent.progress = {
                    duration: durationToPercentage(duration, totalDuration),
                    precedingDuration: durationToPercentage(precedingDuration, totalDuration),
                };

                prepared.precedingDuration += duration;

                return prepared;
            },
            preparedEventsData,
        );

        preparedEventsData.events.push(
            new Event({
                duration: params.duration,
                finishTime: params.finishTime,
                state: 'total',
                phase: 'total',
                showAttributesColumn,
            }),
        );

        return preparedEventsData.events;
    }

    return undefined;
}

export function prepareOperationEvents(operation) {
    const events = ypath.getValue(operation, '/@events');

    return prepareEvents(events, operation);
}

export function prepareJobEvents(job) {
    const events = ypath.getValue(job, '/attributes/events');

    return prepareEvents(events, job);
}
